var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"article_stats_chart fs14"},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),(!_vm.slotmag)?_c('div',{staticClass:"mag"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.contentStr)}})]):_vm._t("default"),_c('div',{staticClass:"report_stats_chart",attrs:{"id":_vm.chartBox}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }